import React, {useState, useEffect} from 'react';
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import {
    triggerSuccess,
    triggerError,
    setErrorMessage,
    setSuccessMessage,
  } from '../Request/StatusFormatter';
  import Settings from '../Settings/Settings';

const Profile = () => {
    const getStoredUser = () => {
        const stored = localStorage.getItem('delox-user');
        return stored ? JSON.parse(stored) : null;
    };

    const [user, setUser] = useState(getStoredUser);

    const initialImage = {
        image: null
    };
    const [formImage, setImage] = useState(initialImage);

    const onFileChange = (event) => {
        setImage({...formImage, image: event.target.files[0]});
    };

    const { isLoading: isSendingRequest, mutate: uploadPhoto } = useMutation(
        async () => {
            const formData = new FormData();
            formData.append('image', formImage.image);
            return await apiClient.post('/api/profile-update', formData);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess();
            localStorage.setItem('delox-user', JSON.stringify(res.data.user));
            setUser(res.data.user);
            setImage(initialImage);
            window.dispatchEvent(new Event('profileUploaded'));
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);
            triggerError();
          },
        }
    );

    useEffect(() => {
        document.title = 'USER PROFILE';

        const syncUser = () => {
            const stored = getStoredUser();
            if (stored) {
                setUser(stored);
            }
        };

        window.addEventListener('profileUploaded', syncUser);
        return () => window.removeEventListener('profileUploaded', syncUser);
    }, []);

    if (!user) {
        return null;
    }

  return (
    <div id="page-content">
        <div className="notch-clear"></div>
       <div className="pt-5 mt-4"></div>
       <div className="card card-style overflow-visible mt-5">
           <div className="mt-n5"></div>
           {formImage.image === null ?
           <img style={{width: "180px", height: "180px", objectFit: "cover"}} src={user.profile} alt="profile" className="mx-auto rounded-circle mt-n5 shadow-l"/>
           :
           <img style={{width: "180px", height: "180px", objectFit: "cover"}} src={URL.createObjectURL(formImage.image)} alt="profile" className="mx-auto rounded-circle mt-n5 shadow-l"/>
           }
           <input onChange={onFileChange} type="file" id='profile-photo' name="profile" accept="image/*" style={{display: "none"}}/>
            <label className='text-center' htmlFor='profile-photo' style={{transform: "translate(20px, -20px)", zIndex: '20'}}>
           <span translate="no" className="material-icons-outlined color-theme" style={{fontSize: "38px"}}>add_a_photo</span>
           </label>
            {formImage.image !== null &&
                <div className='text-center p-8 mb-4 mt-n2'>
                    <button onClick={uploadPhoto} className='btn btn-sm gradient-highlight'>
                        {isSendingRequest ? <span>uploading...</span> : <span>upload photo</span>}
                    </button>
                </div>
            }
           <h1 className="color-theme text-center font-30 pt-0 mb-0">{user.name}</h1>
           <p className="color-theme text-center font-13 opacity-70 mb-3">{user.email}</p>
       </div>
        <Settings onProfileUpdated={setUser} />
    </div>
  )
}

export default Profile
